export default {
  FixedAssetList: {
    FixedAsset: 'Tài sản cố định',
    DictionaryFixedAsset: '/ Tài sản cố định / Tài sản cố định',
    Dictionary: 'Danh mục',
  },
  FixedAssetDetail: {
    Title: {
      PrintReport: 'In thẻ tài sản số định',
      GuaranteeDuration: 'Thời gian bảo hành',
      VenderAddress: 'Địa chỉ nhà cung cấp',
      RemainingLifeTime: 'Thời gian sử dụng còn lại (năm)',
      DepreciationInfo: 'Sửa thông tin hao mòn',
      Save: 'Cất (Ctrl + S)',
      ProductionYear: 'Năm sản xuất',
      MadeIn: 'Nước sản xuất',
    },
    Text: {
      PrintReport: 'In thẻ TSCĐ',
      DepreciationInfo: 'Sửa thông tin HM',
      Help: 'Trợ giúp',
      OtherInfo: 'Thông tin khác',
      GeneralInfo: 'Thông tin chung',
      DepreciationInfoTab: 'Thông tin hao mòn',
      FixedAssetCode: 'Mã tài sản *',
      FixedAssetName: 'Tên tài sản *',
      Quantity: 'Số lượng',
      Unit: 'Đơn vị tính',
      SerialNumber: 'Số hiệu',
      GuaranteeDuration: 'Thời gian BH',
      ProductionYear: 'Năm SX',

      MadeIn: 'Nước SX',

      VenderName: 'Nhà cung cấp',
      VenderAddress: 'Địa chỉ NCC',
      Description: 'Diễn giải',
      IsFixedAssetTransfer: 'Là tài sản điều chuyển',
      PurchasedDate: 'Ngày mua *',
      IncrementDate: 'Ngày ghi tăng',
      UsedDate: 'Ngày sử dụng',
      DepreciationDate: 'Ngày tính hao mòn',
      OrgPrice: 'Nguyên giá (VND) *',
      LifeTime: 'Thời gian sử dụng (năm) *',
      DepreciationRate: 'Tỷ lệ tính hao mòn năm (%)',
      PeriodDepreciationAmount: 'Giá trị hao mòn năm (VND)',
      AccumDepreciationAmount: 'Hao mòn lũy kế (VND)',
      RemainingAmount: 'Giá trị còn lại (VND)',
      RemainingLifeTime: 'Thời gian sử dụng còn lại (năm) *',
      EndYear: 'Đến năm',
      NumberDupplicate: 'Số lượng nhân bản',
      Save: 'Cất',
      Cancel: 'Hủy',
    },
  },
  // combobox => thường dùng chung
  Combobox: {
    Text: {
      FixedAssetCategory: 'Loại tài sản {0}',
      Department: 'Đơn vị sử dụng {0}',
      State: 'Tình trạng',
      OrgPriceAccount: 'TK nguyên giá {0}',
      DepreciationAccount: 'TK hao mòn {0}',
      CapitalAccount: 'TK nguồn {0}',
    },
    Title: {
      OrgPriceAccount: 'Tài khoản nguyên giá',
      DepreciationAccount: 'Tài khoản hao mòn',
      CapitalAccount: 'Tài khoản nguồn',
    },
  },
};
